import moment from "moment-timezone";

export const convertToUTC = (localDateTime, userTimezone) => {
  return moment.tz(localDateTime, userTimezone).utc().format();
};

export const convertToLocal = (utcDateTime, userTimezone) => {
  return moment.utc(utcDateTime).tz(userTimezone).toDate();
};

export const getDateRange = (date, view) => {
  const start = moment(date).startOf(view);
  const end = moment(date).endOf(view);

  // For month view, extend to include partial weeks
  if (view === "month") {
    start.startOf("week");
    end.endOf("week");
  }

  return {
    start: start.format("YYYY-MM-DD"),
    end: end.format("YYYY-MM-DD"),
  };
};

export const formatDateTime = (date, format = "MMM DD, YYYY h:mm A") => {
  return moment(date).format(format);
};

export const formatTime = (date) => {
  return moment(date).format("h:mm A");
};

export const formatDate = (date) => {
  return moment(date).format("MMM DD, YYYY");
};

export const isSameDay = (date1, date2) => {
  return moment(date1).isSame(date2, "day");
};

export const isToday = (date) => {
  return moment(date).isSame(moment(), "day");
};

export const isThisWeek = (date) => {
  return moment(date).isSame(moment(), "week");
};

export const isThisMonth = (date) => {
  return moment(date).isSame(moment(), "month");
};

export const getDurationInMinutes = (start, end) => {
  return moment(end).diff(moment(start), "minutes");
};

export const addMinutes = (date, minutes) => {
  return moment(date).add(minutes, "minutes").toDate();
};

export const getDefaultEventDuration = () => {
  return 120; // 2 hours in minutes
};

export const getBusinessHours = () => {
  return {
    start: 8, // 8 AM
    end: 20, // 8 PM
  };
};

export const isWithinBusinessHours = (date) => {
  const hour = moment(date).hour();
  const businessHours = getBusinessHours();
  return hour >= businessHours.start && hour < businessHours.end;
};

export const getNextBusinessHour = (date) => {
  const businessHours = getBusinessHours();
  const currentHour = moment(date).hour();

  if (currentHour < businessHours.start) {
    return moment(date).hour(businessHours.start).minute(0).second(0).toDate();
  } else if (currentHour >= businessHours.end) {
    return moment(date)
      .add(1, "day")
      .hour(businessHours.start)
      .minute(0)
      .second(0)
      .toDate();
  }

  return date;
};

export const roundToNearestMinutes = (date, minutesToRound = 15) => {
  const minutes = moment(date).minute();
  const rounded = Math.round(minutes / minutesToRound) * minutesToRound;
  return moment(date).minute(rounded).second(0).toDate();
};
